import React from "react";
import "../../App.css";
import Contact from "../footer";
import ScrollArrow from "../ScrollUp";

export default function Contact_page() {
  return (
    <>
      <Contact />
      <ScrollArrow />
    </>
  );
}
